import {useGetPaymentAccountsQuery} from "@/store/payment-accounts.ts";
import {Card, CardContent, CardDescription, CardHeader, CardTitle} from "@/components/ui/card.tsx";
import {Spinner} from "@/components/ui/spinner.tsx";
import {format} from "date-fns";
import {Button} from "@/components/ui/button.tsx";
import {PencilIcon} from "@heroicons/react/24/outline";
import {TooltipContent, TooltipTrigger, Tooltip, TooltipProvider} from "@/components/ui/tooltip.tsx";
import {Dialog, DialogContent, DialogHeader, DialogTrigger, DialogTitle} from "@/components/ui/dialog.tsx";
import {AddCreditCard} from "@/components/add-credit-card.tsx";
import {useState} from "react";


export function PaymentMethod() {
    const {data, isLoading} = useGetPaymentAccountsQuery();
    const paymentAccount = data?.[(data?.length ?? 0) - 1];
    const [openModal, setOpenModal] = useState(false);
    return (
        <Card>
            <CardHeader>
                <CardTitle>אמצעי תשלום</CardTitle>
                <CardDescription>
                    אמצעי התשלום בחשבון זה מהווה אמצעי תשלום עבור כלל המערכות בחשבון.
                </CardDescription>
            </CardHeader>
            <CardContent>
                <TooltipProvider>
                    {paymentAccount && (
                        <div className="border rounded-xl shadow border-gray-200">
                            <div className="p-6 relative">
                                <div className="text-lg font-semibold mb-2">אמצעי תשלום ראשי</div>
                                <div className="text-sm text-gray-500 mb-4">מספר
                                    כרטיס: {paymentAccount.last_digits}</div>
                                <div className="text-sm text-gray-500 mb-2">מותג: {paymentAccount.brand}</div>
                                <div className="text-sm text-gray-500 mb-2">תוקף: {
                                    paymentAccount.exp ? format(new Date(paymentAccount.exp), 'MM/yy') : 'לא זמין'
                                }</div>

                                <div className="absolute top-4 end-4">
                                    <Tooltip>
                                        <Dialog open={openModal} onOpenChange={setOpenModal}>
                                            <DialogTrigger asChild>
                                                <span>
                                                    <TooltipTrigger asChild>
                                                    <Button size="icon" variant="ghost">
                                                        <PencilIcon className="w-5 h-5"/>
                                                    </Button>
                                                    </TooltipTrigger>
                                                    <TooltipContent>
                                                        <p>עריכת אמצעי תשלום</p>
                                                    </TooltipContent>
                                                </span>
                                            </DialogTrigger>
                                            <DialogContent>
                                                <DialogHeader>
                                                    <DialogTitle>עדכן כרטיס אשראי</DialogTitle>
                                                </DialogHeader>
                                                <div className="p-6 pt-0">
                                                    <AddCreditCard
                                                        id={paymentAccount.id}
                                                        onSuccess={() => setOpenModal(false)}
                                                    />
                                                </div>
                                            </DialogContent>
                                        </Dialog>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    )}
                </TooltipProvider>

                {isLoading && <Spinner size="lg"/>}
            </CardContent>
        </Card>
    )
}